import React, {useEffect, useState} from "react";
import {Tabs} from 'antd';
import { termsConfig } from '../../../config/terms.config.js';
import { useLocation, useHistory } from 'react-router-dom';
export default function PrivacyPage() {

  const { TabPane } = Tabs;
  const location = useLocation();
  const history = useHistory();

  // Получаем параметр tab из URL
  const getActiveTab = () => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab === 'terms') return '1';
    if (tab === 'offer') return '2';
    if (tab === 'agreement') return '3';
    return '1'; // По умолчанию первая вкладка
  };

  const [activeKey, setActiveKey] = useState(getActiveTab());

  const handleTabChange = (key) => {
    setActiveKey(key);
    // Обновляем URL при смене вкладки
    let tabParam = '';
    if (key === '1') tabParam = 'terms';
    if (key === '2') tabParam = 'offer';
    if (key === '3') tabParam = 'agreement';
    history.replace(`?tab=${tabParam}`);
  };

  // Следим за изменением URL
  useEffect(() => {
    setActiveKey(getActiveTab());
  }, [location.search]);

  return (
      <div className="privacy container">
        <Tabs
            activeKey={activeKey}      
            onChange={handleTabChange}  
            type="card"
        >
          <TabPane
              tab={<p className="privacy__tab-title">Политика в&nbsp;отношении<br />обработки персональных данных</p>}
              key="1"
          >
            {termsConfig.terms_text}
          </TabPane>

          <TabPane
              tab={<p className="privacy__tab-title">Публичная оферта о&nbsp;согласии<br />с&nbsp;обработкой персональных данных</p>}
              key="2"
          >
            {termsConfig.offer_text}
          </TabPane>

          <TabPane
              tab={<p className="privacy__tab-title">Пользовательское соглашение</p>}
              key="3"
          >
            {termsConfig.terms_of_use_text}
          </TabPane>
        </Tabs>
      </div>
  );
}
